import { extract, inject } from "../../functions/queryHelpers";
import { mappingSchema } from "./mappings"

export function mappingModel() {
    const mapBySchema = (source, target, schema) => {
        schema.forEach(_ => {
            const sourceMember = _.sourceMember;

            const targetMember = _.targetMember;
            let value = extract('', sourceMember, source);
            
            // if (targetMember.startsWith("forwarder_full_name")) {
            //     debugger;
            // }

            switch (_.targetMemberType) {
                case 'date':
                    case 'datetime':
                    value = new Date(value); break;
            }
            if (_.sourceMemberMap) {
                value = _.sourceMemberMap(value);
            }
            inject('', targetMember, target, value);
        })
    }
    return {
        map: (objectReferral, act, result, protocol, resolution, prescription) => {
            let mapSchema = [];
            const schema = mappingSchema;
            if (resolution) {
                mapSchema = schema.filter(_ => _.sourceType == 'resolution')
            }
            else if (prescription) {
                mapSchema = schema.filter(_ => _.sourceType == 'prescription')
            }            
            else if (act) {
                mapSchema = schema.filter(_ => _.sourceType == 'act')
            }
            else if (objectReferral) {
                mapSchema = schema.filter(_ => _.sourceType == 'objectReferral')
            }
            else if (result) {
                mapSchema = schema.filter(_ => _.sourceType == 'result')
            }
            const object = act || resolution || prescription || objectReferral || result;
            if (result && object != result) {
                const resultSchema = mapSchema.filter(_ => _.targetType == 'result' && (!_.targetNumber || _.targetNumber == result.form.number))
                mapBySchema(object, result, resultSchema)
            }
            else if (protocol) {
                const protocolSchema = mapSchema.filter(_ => _.targetType == 'protocol' && (!_.targetNumber || _.targetNumber == protocol.form.number))
                mapBySchema(object, protocol, protocolSchema)
            }
            else if (objectReferral) {
                const protocolSchema = mapSchema.filter(_ => _.targetType == 'objectReferral')
                mapBySchema(object, objectReferral, protocolSchema)
            }
        },
       
    }
}